import ListItem from './ListItem';

export interface CidadeResult {
  idCidade: number;
  uf: string;
  nomeCidade: string;
}

export interface TipoLogradouroResult {
  idTipoLogradouro: number;
  sigla: string;
  nome: string;
}

export interface Sale {
  idProvedor: number;
  idProduto: number;
  idVendedor: number;
  tipoDocumento: string;
  documento: string;
  nome: string;
  nomeFantasia: string;
  endereco: {
    cep: string;
    idTipoLogradouro: number;
    endereco: string;
    numero: string;
    bairro: string;
    uf: string;
    idCidade: number;
    complemento: string;
  };
  email: string;
  confirmacaoEmail: string;
  telefone: string;
  tipoAtendimento: string;
}


export function MapperStringListItem(data: string[]): ListItem[] {
  return data.map((item) => {
    return {
      text: item,
      value: item,
    } as ListItem;
  });
}

export function MapperCidadeListItem(data: CidadeResult[]): ListItem[] {
  return data.map((item) => {
    return {
      text: item.nomeCidade,
      value: item.idCidade.toString(),
    } as ListItem;
  });
}

export function MapperTipoLogradouroListItem(
  data: TipoLogradouroResult[]
): ListItem[] {
  return data.map((item) => {
    return {
      text: item.sigla,
      value: item.idTipoLogradouro.toString(),
    } as ListItem;
  });
}
